<template>
  <div class="dispatcher-history">
    <div class="modal dispatcher-history-modal" style="position: absolute!important">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <div class="panel-heading">
            <span class="has-text-weight-semibold">{{ $t("driver.completed-transactions") }}</span>
            <table
              v-if="isSiilor"
              class="table is-fullwidth"
              style="background-color:rgba(0, 0, 0, 0);"
            >
              <tbody>
                <tr>
                  <td>
                    <span
                      class="cash button is-link is-fullwidth has-text-weight-semibold is-outlined"
                      @click="toggle('cash')"
                    >{{ $t("cash") }}</span>
                  </td>
                  <td>
                    <span class="tukpay button is-link is-fullwidth" @click="toggle('tukpay')">
                      <img v-if="isSiilor" src="../assets/tukpay.png" style="height:20px" />
                    </span>
                  </td>
                  <td>
                    <span
                      class="total button is-link is-fullwidth has-text-weight-semibold is-outlined"
                      @click="toggle('price')"
                    >{{ $t("total") }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="hasHistory" style="max-height:55vh; overflow:scroll">
            <div v-for="i in 7" :key="i">
              <a class="panel-block">
                <span
                  class="tag is-medium has-text-weight-semibold"
                  v-if="i === 1"
                >{{ new Date().toLocaleDateString("en-GB") }}, {{ $t("today") }}</span>
                <span class="tag is-medium has-text-weight-semibold" v-else>{{ daysAgo(i-1) }}</span>
                <!-- <span class="tag is-medium is-warning" v-if="isSiilor">{{ dailyEarnings(i-1) }}</span> -->
                <span class="tag is-medium is-warning" v-if="isSiilor">{{ dailyTukpay(i-1) }}</span>
              </a>
              <a
                class="panel-block"
                v-for="t in thisDay(i-1)"
                :key="t.id"
                style="background-color:#f5f5f5"
                @click="transactionDetail(t)"
              >
                <span class="tag">{{ shortTime(t) }}</span>
                &nbsp;
                <span
                  class="tag is-warning"
                  v-if="earnings(t)"
                >{{ earnings(t) }}</span>
                &nbsp;
                <span class="tag is-success">{{ t.data.pickup_stop.name }}</span>&nbsp;
                <span
                  v-if="t.data.dropoff_stop"
                  class="tag is-link"
                >{{ t.data.dropoff_stop.name }}</span>&nbsp;&nbsp;
              </a>
            </div>
          </div>
          <div v-else>
            <p v-if="!updating">{{ $t("driver.history-will-appear-here") }}</p>
          </div>
        </section>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "DispatcherHistoryModal",
  components: {},
  data() {
    return {
      history: [],
      todays: [],
      yesterdays: [],
      updating: false,
      selected: "price", // total price is default selection
      workflowID: null
    };
  },
  computed: {
    yesterdaysDate() {
      var ytd = new Date().getTime() - 86400 * 1000;
      return new Date(ytd).toLocaleDateString("en-GB");
    },
    isSiilor() {
      if (!this.history) return false;
      if (this.history.length === 0) return false;
      if (this.history[0].workflow_type_name === "Sii Lor") return true;
      return false;
    },
    hasHistory() {
      if (!this.history) return false;
      if (this.history.length === 0) return false;
      return true;
    }
  },
  created() {},
  mounted() {
    EventBus.$on("DISPATCHER_HISTORY", workflowID => {
      this.workflowID = workflowID;
      console.log("DISPATCHER_HISTORY", workflowID);
      this.history = []; // reset
      this.getHistory();
    });
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    transactionDetail(t) {
      if (!t.data.fare) return;
      var cash = this.$t("cash");
      var total = this.$t("total");
      var createdAt = new Date(t.created_at).toLocaleString("en-GB");
      var stops = `${this.$t("driver.pickup-at")} ${t.data.pickup_stop.name}`;
      if (t.data.dropoff_stop) {
        stops += `<br>
        ${this.$t("driver.dropoff-at")} ${t.data.dropoff_stop.name}`;
      }
      this.$swal({
        title: this.$t("driver.transaction-details"), //"Transaction Details",
        html: `<div style="text-align:left"><i>${createdAt}</i><br>
                ${stops}</div><hr>
                <div style="text-align:right">
                ${cash}: ฿${t.data.fare.cash}<br>
                TukPay: ฿${t.data.fare.tukpay}<br>
                --------------<br>
                <strong>${total}: ฿${t.data.fare.price}</strong></div>`,
        showConfirmButton: false
      });
    },
    daysAgo(n) {
      var t = new Date().getTime() - 86400 * 1000 * n;
      return new Date(t).toLocaleDateString("en-GB");
    },
    thisDay(n) {
      var date = new Date().getTime() - 86400 * 1000 * n;
      return this.history.filter(t => {
        // console.log("thisDay", t.created_at, date);
        return this.sameDate(t.created_at, date);
      });
    },
    dailyEarnings(n) {
      var date = new Date().getTime() - 86400 * 1000 * n;
      var daily = this.history.filter(t => {
        // console.log("thisDay", t.created_at, date);
        return this.sameDate(t.created_at, date);
      });
      var freeCnt = daily.filter(t => t.data.price === "free").length;
      var normalCnt = daily.filter(t => t.data.price !== "free").length;
      var earnings = freeCnt * 70 + normalCnt * 20;
      return `${daily.length} trips, ฿${earnings}`; // deprecated!
    },
    dailyTukpay(n) {
      var date = new Date().getTime() - 86400 * 1000 * n;
      var daily = this.history.filter(t => {
        return this.sameDate(t.created_at, date);
      });
      var earnings = 0;
      daily.forEach(t => {
        if (t.data.fare) earnings += t.data.fare[this.selected];
      });
      return `${daily.length} trips, ฿${earnings}`; // change name to dailyEarnings()
    },
    sameDate(d1, d2) {
      d1 = new Date(d1);
      d2 = new Date(d2);
      return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
      );
    },
    sameDay(d1, d2) {
      return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
      );
    },
    today(d) {
      return this.sameDay(new Date(d), new Date());
    },
    yesterday(d) {
      var ytd = new Date().getTime() - 86400 * 1000;
      return this.sameDay(new Date(d), new Date(ytd));
    },
    shortTime(t) {
      var str = new Date(t.created_at).toLocaleTimeString("en-GB");
      return str.slice(0, 5);
    },
    getHistory() {
      var loader = this.loadingDots();
      this.updating = true;
      this.$store
        .dispatch("getDispatcherHistory", this.workflowID)
        .then(res => {
          console.log("getDispatcherHistory", res.data);
          this.history = res.data;
          if (this.history) {
            this.todays = this.history.filter(t => {
              return this.today(t.created_at);
            });
            this.yesterdays = this.history.filter(t => {
              return this.yesterday(t.created_at);
            });
          }
        })
        .catch(err => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.updating = false;
        });
    },
    compute() {
      // first try to set todays
      var now = new Date();
      //   this.todays = this.history;
      this.history.forEach(t => {
        var d = new Date(t.created_at);
        // console.log("loop over t", t, d);
        if (this.sameDay(now, d)) {
          //   console.log("same day");
          this.todays.push(t);
        }
      });
    },
    transactionStyle(t) {
      var color = "pink";
      if (t.state === "alighted") color = "lightgreen";
      var liveStates = ["initiated", "confirmed", "driver_arrived", "enroute"];
      if (liveStates.includes(t.state)) color = "lightblue";
      return `background-color: ${color}`;
    },
    green(isOngoing) {
      if (isOngoing) return `background-color: lightgreen`;
      return `background-color: pink`;
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    bonus(t) {
      if (!t.data.price) return false;
      if (t.data.price === "free") return "+70";
      return "+20"; // deprecate!
    },
    tukpay(t) {
      if (!t.data.fare) return false;
      if (t.data.fare.tukpay > 0) return `+${t.data.fare.tukpay}`;
      return false; // deprecate
    },
    earnings(t) {
      if (!t.data.fare) return false;
      // if (t.data.fare[this.selected] > 0)
      return `+${t.data.fare[this.selected]}`;
      // return false; // deprecate
    },
    toggle(type) {
      console.log("toggle", type);
      this.selected = type; // set type
      this.$el.querySelectorAll(".button").forEach(el => {
        el.classList.add("is-outlined");
      });
    }
  }
};
</script>

<style scoped>
div.panel-heading {
  padding: 10px 5px;
}
.panel-block {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
}
.panel-block::-webkit-scrollbar {
  display: none;
}
td {
  padding: 2px 2px;
}
.modal-card-body {
  padding: 12px;
}
</style>